let routes = [
    {
        path: '/menu-management',
        name: 'menu-management',
        component: () => import('@/modules/managers/menuManagement/MenuManagement.vue')
    }
]

export default routes
